<template>
  <div class="match">
    <div v-if="true" class="top-content">
      <img src="@/assets/onehour/gamebanner.png" alt style="margin:auto;display:block;" />
    </div>
    <div class="wd">
      <div class="match-content">
        <Row type="flex" justify="space-between" style="margin: 20px 0;">
          <i-col span="5" class="card-list" v-for="(item, index) in frameList" :key="index">
            <Card :shadow="true" class="card">
              <div class="pic" @click="toFrame(item)">
                <img :src="item.frameCoverUrl" alt />
              </div>
              <div class="content" @click="toFrame(item)">
                <p class="title">{{item.frameName}}</p>
                <p class="desc">{{item.frameDesc}}</p>
              </div>
            </Card>
          </i-col>
        </Row>
      </div>
    </div>
  </div>
</template>
<script>
import request from "@/api/axios";
export default {
  name: "match",
  data() {
    return {
      frameList: {},
    };
  },
  created() {
    this.getFrameList();
  },
  methods: {
    getFrameList() {
      request({
        url: "/api/teaching/teachingFrame/list?frameType=1&pageSize=999",
        method: "get",
      }).then((res) => {
        if (res.success) {
          this.frameList = res.result.records;
        }
      });
    },
    toFrame(item) {
      if (item.frameTarget == 2) {
        window.open(item.frameUrl);
      } else {
        this.$router.push({
          path: `/frame?page=${item.frameUrl}`,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.match {
  .list {
    font-weight: 700;
    background: #fff;
    border-radius: 10px;
    padding: 2px 15px;
    .ivu-list-item {
      position: relative;
      opacity: 0.7;
      padding: 15px 0;
      &:hover {
        opacity: 1;
      }
      .ivu-list-item-meta-title {
        color: #333;
        font-size: 15px;
        font-weight: 700;
      }
      .ivu-avatar {
        width: 95px;
        height: 66px;
        border-radius: unset;
      }
    }
  }
}
.course-modal {
  position: relative;
  .ivu-modal-footer {
    display: none;
  }
  .ivu-modal-body {
    padding: 60px 20px 40px 20px;
  }
  .ivu-modal-content {
    background-color: rgba(215, 215, 215, 1);
    border-radius: 8px;
  }
  .plusnum {
    right: 0;
    box-shadow: 2px 0px 4px 0 rgba(0, 0, 0, 0.3);
  }
}
.battle-modal {
  position: relative;
  .ivu-modal-footer {
    display: none;
  }
  .battle {
    width: 600px;
    height: 395px;
  }
  .ivu-modal-body {
    background-image: linear-gradient(45deg, #03cafd, #68efba);
    padding: 0;
    font-size: 0;
    border-radius: 6px;
  }
  .close {
    position: absolute;
    right: 0;
    top: 0;
    width: 38px;
    height: 33px;
  }
}
.plusnum {
  position: absolute;
  right: 12px;
  top: -20px;
  color: #fff;
  background: #fff;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  span {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  &::before {
    background: #ff0066;
    width: 38px;
    height: 38px;
    content: "";
    position: absolute;
    border-radius: 50%;
    right: 1px;
    top: 1px;
  }
}
</style>
<style lang="scss" scoped>
.match {
  text-align: left;
  .top-content {
    background: url("../../assets/match/bg.jpg") no-repeat -330px 0;
    background-size: 142% 86%;
    margin-top: -80px;
    padding-top: 80px;
    height: 450px;
  }
  .match-content {
    margin-bottom: 30px;
    .title {
      .icon {
        font-size: 43px;
        vertical-align: middle;
      }
      .tip {
        color: #333;
        font-weight: 700;
        font-size: 24px;
        vertical-align: middle;
      }
    }
    .cards {
      margin-top: 30px;
      font-size: 13px;
      .card-list2 {
        width: 522px;
        margin-bottom: 50px;
        position: relative;
        &:nth-child(2n + 1) {
          margin-right: 60px;
        }
        .icon {
          border-radius: 10px;
          width: 522px;
          height: 277px;
        }
        .card-bottom {
          padding: 0 30px;
          .title {
            font-size: 16px;
            margin: 15px -30px;
            padding-left: 30px;
            .status {
              font-size: 14px;
              color: #ff3366;
              font-weight: 700;
              font-style: oblique;
              background: #d7d7d7;
              padding: 0 10px;
              line-height: 26px;
            }
          }
          p {
            padding-bottom: 15px;
          }
        }
        .oparate {
          position: absolute;
          bottom: 10px;
          right: 10px;
          button {
            border-color: rgb(255, 51, 102);
            color: rgb(255, 51, 102);
            &.btn1 {
              background: rgb(255, 51, 102);
              color: #fff;
              margin-right: 10px;
            }
          }
        }
      }
    }

    .card-list {
      // margin-right: 40px;
      margin-bottom: 50px;
      .card {
        width: 260px;
        text-align: left;
        color: #999;
        .pic {
          width: 100%;
          height: 185px;
          overflow: hidden;
          img {
            width: 100%;
            height: 185px;
            transition: all 0.2s ease-out;
            opacity: 0.7;
            &:hover {
              opacity: 1;
            }
          }
        }
        .content {
          padding: 8px 20px;
          .title {
            color: #333;
            font-size: 14px;
          }
        }
        .footer {
          padding: 4px 20px;
        }
      }
    }
    .work-file {
      .list {
        margin-top: 24px;
        .grade {
          font-size: 20px;
          color: #f59a23;
          position: absolute;
          right: 0;
          bottom: 10px;
        }
      }
      p {
        font-size: 18px;
        text-align: center;
        font-weight: 400;
        line-height: 60px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/gamecourse.vue